<script>
	import { validator } from "../validation";
	import MedicalProviderModel from "../models/MedicalProvider";

	import MedicalProvider from "./MedicalProvider.svelte";
	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";
	import AddButton from "./buttons/AddButton.svelte";

	export let medicalProviders = [];
	export let disabled = null;

	let isProviderValid = [];

	const deleteMedicalProvider = (index) => {
		if (medicalProviders.length <= 1) return;
		medicalProviders.splice(index, 1);
		medicalProviders = [...medicalProviders];
	};

	const addMedicalProvider = () => {
		var errors = medicalProviderValidator.isValid();
		if (errors.length !== 0) {
			return;
		}

		medicalProviders = [...medicalProviders, new MedicalProviderModel()];
	};

	export const medicalProviderValidator = {
		isValid() {
			return isProviderValid.length ? document.querySelectorAll("#medical-providers .error-message") : [];
		}
	};

	if (!medicalProviders.length) {
		medicalProviders = [new MedicalProviderModel()];
	}
</script>

<div id="medical-providers">
	<FormRow class="mt-0">
		<FormColumn cols="3" class="d-none d-md-block">
			<!-- svelte-ignore a11y-label-has-associated-control -->
			<label>Medical Provider Name</label>
		</FormColumn>
		<FormColumn cols="3" class="d-none d-md-block">
			<!-- svelte-ignore a11y-label-has-associated-control -->
			<label>Specialty</label>
		</FormColumn>
		<FormColumn cols="3" class="d-none d-md-block">
			<!-- svelte-ignore a11y-label-has-associated-control -->
			<label>From</label>
		</FormColumn>
		<FormColumn cols="3" class="d-none d-md-block">
			<!-- svelte-ignore a11y-label-has-associated-control -->
			<label>To</label>
		</FormColumn>
	</FormRow>

	{#each medicalProviders as medicalProvider, i (medicalProvider)}
		<MedicalProvider
			{disabled}
			bind:medicalProvider
			numberOfMedicalProviders={medicalProviders.length}
			on:delete-medical-provider={() => deleteMedicalProvider(i)}
			bind:validator={isProviderValid}
		/>
	{/each}

	<div class="confirmation-hide" style="margin-top: 26px;">
		<AddButton on:add={addMedicalProvider}>Add provider</AddButton>
	</div>
</div>
